import { useContext, useEffect, useMemo, useState } from "react";
import { usePagination, useTable } from "react-table";
import { Get } from "../Rutas/ApiRest";
import "../index.css"
import { RastreoInicial } from "../Model/Tablas/RastreoCarga";
import { Contexto } from "../Context/Contexto";
import { GuiaBusquedaCont } from "../Context/BusquedaGuiaContext";
import { tokens } from "../Context/Tokens";
import { MensajeContActualizacion } from "../Context/MensajeContextActualizacion";
import { cuentaCliente } from "../Rutas/Servicios";
import { HistorialPuntosInicial, HistorialPuntosTabla } from "../Model/Tablas/HistorialPuntos";

function HistorialPuntos() {
  
 
    const {tok}=useContext(tokens)
    const {Cli}=useContext(Contexto)
    const {SetLoading}=useContext(MensajeContActualizacion)
    const [Totales,SetTotales]=useState(0)
    const [PorVencer,SetPorVencer]=useState(0)
    const datos=[
        HistorialPuntosInicial
      ]
      const columns=useMemo(() => HistorialPuntosTabla, [])
      const dato=useMemo(() => datos, [])
      const [data,Setdata]=useState(dato)

     useEffect(()=>{
        SetLoading(true)
        ActualizarDatos();
        
     },[Cli.Eleccion])

     const ActualizarDatos=()=>
     {
        if(Cli.lCasilla[Cli.Eleccion].ecode!=undefined)
        {
            if(Cli.lCasilla[Cli.Eleccion].ecode!="")
            {
                const PuntosVencer=Get(cuentaCliente.PuntosPorVencer.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
                PuntosVencer.then((e:any)=>{SetTotales(e.total);SetPorVencer(e.puntosPorVencer)})

                const historialcargas=Get(cuentaCliente.HistorialPuntosRewards.replace("@ecode",Cli.lCasilla[Cli.Eleccion].ecode),"application/json",tok)
                historialcargas.then(resultado=>{Setdata(resultado);console.log(resultado)})
            }
        }
        SetLoading(false)
     }

          const {
            getTableProps, 
            getTableBodyProps, 
            headerGroups, 
            page,
            nextPage,
            previousPage,
            canNextPage,
            canPreviousPage,
            pageOptions,
            gotoPage,
            pageCount,
            state,
            prepareRow,
        } = useTable({
                // @ts-ignore
                columns,
                data,
            },
            usePagination
        );

        const { pageIndex } = state
    return (
        <>

<section className="section">
                <div className="row row__item" style={{justifyContent:"center"}}>
                <div className="col-6 col-md-4" >
                
                
                <div >
                    <div className="col-12" >
                        <div className="card-body" style={{textAlign:"center"}}>
                            <h5 ><strong>Total de Puntos Rewards</strong></h5>
                            
                            <h5><strong>{Totales} Pts</strong></h5>
                        </div>
                    </div>
                </div>    
            
            
        </div>
        <div className="col-6 col-md-4">
                
                
                <div >
                    <div className="card-body" style={{textAlign:"center"}}>
                        <h5><strong>Vencen este mes</strong></h5>
                        <h5><strong>{PorVencer} Pts</strong></h5>
                    </div>
                </div>    
            
            
        </div>
                </div>
            </section>
            {Totales<60?<div className="alert alert-warning alert-dismissible fade show" role="alert" style={{textAlign:"center"}}><span className="content small" >Recuerda que en el programa de Puntos Rewards, el mínimo de puntos necesarios para canjear es 60. No te preocupes, solo te faltan <strong>{60-Totales}</strong> puntos</span>
                <br/>
            <span className="content small">¡Acumula tus puntos y obtén descuento en transporte aéreo!</span>
                
                </div>:null}
                <div className="card-body" style={{textAlign:"center"}}>
                <h3>Mi Historial de Puntos Rewards</h3>
                </div>
        

        {data.length===0?<div><div className="alert au-alert-success alert-dismissible fade show au-alert au-alert--100per" role="alert" id="movPuntosRewards"> <div className="card-body" style={{textAlign:"center"}}><span className="content" >No tienes historial de puntos rewards</span></div>

                    </div></div>:<div className="row">
            <div className="col-12 py-2 py-sm-0">
              <div className="table-responsive" >
                     <table  {...getTableProps()} className="table table-striped">
                       <thead style={{verticalAlign:"middle"}}>
                           {headerGroups.map((headerGroup) => (
                               <tr {...headerGroup.getHeaderGroupProps()}>
                                   {headerGroup.headers.map((column) => (
                                       <th {...column.getHeaderProps()}>
                                           {column.render('Header')}
                                       </th>
                                   ))}
                               </tr>
                           ))}
                       </thead>

                       <tbody {...getTableBodyProps()} style={{verticalAlign:"top",textAlign:"center"}}>
                           {page.map((row: any) => {
                               prepareRow(row)
                               return (
                                   <tr {...row.getRowProps()} 
                                    >
                                       {row.cells.map((cell: any) => {
                                        var fechaEspecifica:any=new Date()
                                        let options = {year: 'numeric', month: '2-digit', day: '2-digit' };
                                        if(cell.column.Header==="Fecha Movimiento")
                                            {
                                                fechaEspecifica = new Date(cell.value);
                                            }

                                           return (
                                            cell.column.Header==="Puntos"?
                                            cell.value>0?<td {...cell.getCellProps()} style={{color:"green"}}><strong> +{cell.render('Cell')}</strong></td>:
                                            <td {...cell.getCellProps()} style={{color:"red"}}> <strong>{cell.render('Cell')}</strong></td>:
                                            cell.column.Header==="Fecha Movimiento"?
                                           <td {...cell.getCellProps()} > {fechaEspecifica.toLocaleString('es-ES',options)}</td>
                                            :<td {...cell.getCellProps()} >{cell.render('Cell')}</td>
                                           );
                                       })}
                                   </tr>
                               );
                           })}
                       </tbody>
                   </table>   
              </div>
			  </div>
		  </div>

                    }

{data.length>10?<div className="table-pagination" style={{margin: '5px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <a >
                    
                    <button onClick={() => previousPage()} disabled={!canPreviousPage} className="btn btn-success">
                        Anterior
                    </button>
                </a>
                <span>
                    <strong style={{display: 'block', width: '100px', textAlign: 'center'}}>
                        {pageIndex + 1} / {pageOptions.length} 
                    </strong>
                </span>
                <a >
                    <button onClick={() => nextPage()} disabled={!canNextPage} className="btn btn-success" >
                        Siguiente
                    </button>
                   
                </a>
                
            </div>:null}

        </>
      
    );
  }
  
  export default HistorialPuntos;